import { render, staticRenderFns } from "./sobatch.vue?vue&type=template&id=06866750&scoped=true&"
import script from "./sobatch.vue?vue&type=script&lang=js&"
export * from "./sobatch.vue?vue&type=script&lang=js&"
import style0 from "./sobatch.vue?vue&type=style&index=0&id=06866750&lang=scss&scoped=true&"
import style1 from "./sobatch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06866750",
  null
  
)

export default component.exports